import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';

// A route table and nothing else, so the module can grow a sub-route without
// anyone editing config/routes.tsx. FNP-1412.
//
// Deliberately does no permission checking. IndexPage gates itself on
// GetDashboard and holds a loader while the decisions are in flight (FNP-1410);
// repeating that here would be a second source of truth for the same rule, which
// is what the previous layout in this app got wrong before it was deleted.
export const DashboardLayout = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={<IndexPage/>}
            />
        </Routes>
    );
};
